export const MAX_CROSS_SELLING_ITEM_COUNT = 8;
